import parsePhoneNumberFromString from "libphonenumber-js";
import { z } from "zod";

export const ValidationSchemas = {
  Email: z.string().trim().toLowerCase().min(1).email(),
  Name: z.string().trim().min(1),
  PhoneNumber: z
    .string()
    .trim()
    .min(1)
    .transform((raw, ctx) => {
      const phone = parsePhoneNumberFromString(raw, {
        defaultCountry: "DE",
        extract: false,
      });

      if (phone && phone.isValid()) return phone.number as string;

      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Invalid phone number",
      });

      return z.NEVER;
    }),
};
